module.exports = __webpack_public_path__ + "assets/img/H.26d543ae.png";